import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

const APIVersionConfirmDialog = ({ open, onClose, onConfirm, isPending, isPartner }) => {
  const handleClose = () => {
    if (isPending) return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="api-version-confirm-title"
      aria-describedby="api-version-confirm-description"
      maxWidth={false}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: 480,
          borderRadius: 2,
          border: 1,
          borderColor: 'divider',
        },
      }}
    >
      <DialogTitle
        id="api-version-confirm-title"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          fontWeight: 600,
          fontSize: '1.125rem',
        }}
      >
        Confirm API Version Change?
        <IconButton onClick={handleClose} size="small" disabled={isPending} aria-label="Close">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography
          id="api-version-confirm-description"
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: '0.875rem', lineHeight: 1.6 }}
        >
          Switching to a new version will immediately change the validation rules for your incoming invoices and the
          data structure of outgoing webhooks. This may break existing integrations if your system is not prepared.
        </Typography>

        {isPartner && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontSize: '0.875rem', lineHeight: 1.6 }}>
            This change will also update all sub-organizations provisioned by your partner account.
          </Typography>
        )}

        <Stack direction="row" justifyContent="flex-end" sx={{ pt: 3 }}>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={isPending}
            sx={{ textTransform: 'none', minWidth: 140 }}
          >
            Confirm & Update
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default APIVersionConfirmDialog;
